const ScoreIcon = (): React.ReactElement => {
  return (
    <svg viewBox="0 0 15 15">
      <circle cx="50%" cy="50%" r="4" fill="#174174" stroke="#174174" strokeWidth="2" />
    </svg>
  );
};

export default ScoreIcon;
